import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { LOGIN_ROUTE } from "../utils/constants";
import { selectCurrentUser } from "../../store/slices/currentUserSlice";

export const Protected = () => {
  const currentUser = useSelector(selectCurrentUser);
  const location = useLocation();

  if (currentUser) return <Outlet />;

  return <Navigate to={LOGIN_ROUTE} state={{ from: location }} replace />;
};
